import { useNavigate } from "react-router-dom";
import loginImage from "../../assets/images/loginImage.png";
import { isLoggedIn } from "../../service/auth.service";
import { useEffect } from "react";
import SignIn from "../../components/Login/SignIn";

const SignForm = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn()) navigate("/");
  }, []);

  return (
    <div className="h-screen w-screen flex relative">
      <img src={loginImage} alt="" className="h-screen w-full absolute object-cover" />
      <div className="w-full h-screen flex items-center justify-center z-10 relative">
        <div className="bg-white bg-opacity-40 backdrop-blur-lg max-w-md w-full p-8 rounded-3xl shadow-lg mr-10">
          <SignIn />
        </div>
      </div>
    </div>

  );
};

export default SignForm;
